import { useCallback, useEffect, useState } from "react";
import WebLayout from "../../../layout/WebLayout";
import CategoryAction from "../../../stores/actions/categoryAction";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../stores";
import profileAction from "../../../stores/actions/profileAction";
import ProfileAction from "../../../stores/actions/profileAction";
import { set } from "react-hook-form";

function EditSellerProfile() {
  const { stateList } = useSelector((state: RootState) => state.profile);
  const { cityList } = useSelector((state: RootState) => state.profile);
  const dispatch = useDispatch()<any>;

  const [name, setName] = useState<any>();
  const [repName, setRepName] = useState<any>();
  const [address, setAddress] = useState<any>();
  const [state, setState] = useState<any>();
  const [stateName, setStateName] = useState<any>();
  const [district, setDistrict] = useState<any>();
  const [pincode, setPinCode] = useState<any>();
  const [mobile, setMobile] = useState<any>();
  const [gstNo, setGstNo] = useState<any>();

  const { profileDetails } = useSelector((state: RootState) => state.auth);

  const setData = useCallback(() => {
    setName(profileDetails?.name_of_entity || "");
    setRepName(profileDetails?.rep_name || "");
    setMobile(profileDetails?.mobile || "");
    setAddress(profileDetails?.address || "");
    setState(profileDetails?.stateName + "|" + profileDetails?.state || "");
    setDistrict(profileDetails?.district || "");
    setPinCode(profileDetails?.pincode || "");
    setGstNo(profileDetails?.gst_no || "");
  }, [
    profileDetails?.name_of_entity,
    profileDetails?.rep_name,
    profileDetails?.mobile,
    profileDetails?.address,
    profileDetails?.state,
    profileDetails?.stateName,
    profileDetails?.district,
    profileDetails?.pincode,
    profileDetails?.gst_no,
  ]);

  useEffect(() => {
    setData();
  }, [setData]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    await dispatch(
      profileAction.updateProfile({
        name,
        repName,
        mobile,
        state,
        district,
        pincode,
        address,
        gstNo,
      })
    );
    await dispatch(profileAction.getProfile());
  };

  const getCategoryList = useCallback(async () => {
    await dispatch(
      CategoryAction.getCategory({
        search: "",
        limit: 1000,
        offset: 0,
        keyword: "",
        sortBy: "",
        sortType: "",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    getCategoryList();
  }, [getCategoryList]);

  const getStateList = useCallback(async () => {
    await dispatch(ProfileAction.getState());
  }, [dispatch]);

  const getCityList = useCallback(async () => {
    if (state) {
      await dispatch(
        ProfileAction.getCity({
          state_id: state + "|" + profileDetails?.state,
        })
      );
    }
  }, [dispatch, state, profileDetails?.state]);

  useEffect(() => {
    getStateList();
  }, [getStateList]);

  useEffect(() => {
    getCityList();
  }, [getCityList, state]);

  return (
    <WebLayout pageName={"EditSellerProfile"}>
      <div className="content-wrapper">
        <div className="container-fluid flex-grow-1 container-p-y">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <form className="needs-validation" onSubmit={handleSubmit}>
                  <h4 className="card-header p-3 fw-bold card_header">
                    Update Profile
                  </h4>
                  <div className="card-body mt-3">
                    <div className="form-validation">
                      <div className="row">
                        <div className="col-xl-6">
                          <div className="mb-3 row">
                            <label className="col-lg-4 col-form-label">
                              Entity Name
                            </label>
                            <div className="col-lg-8">
                              <input
                                type="text"
                                className="form-control"
                                id="validationCustom01"
                                placeholder={`${name}`}
                                required
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-6">
                          <div className="mb-3 row">
                            <label className="col-lg-4 col-form-label">
                              Representative Name
                            </label>
                            <div className="col-lg-8">
                              <input
                                type="text"
                                className="form-control"
                                id="validationCustom01"
                                placeholder="Enter Rep Name"
                                required
                                value={repName}
                                onChange={(e) => setRepName(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-6">
                          <div className="mb-3 row">
                            <label className="col-lg-4 col-form-label">
                              Mobile
                            </label>
                            <div className="col-lg-8">
                              <input
                                type="text"
                                className="form-control"
                                id="validationCustom01"
                                placeholder="Enter Mobile"
                                value={mobile}
                                maxLength={10}
                                onChange={(e) => {
                                  const numericValue = e.target.value.replace(
                                    /\D/g,
                                    ""
                                  );
                                  setMobile(numericValue);
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-6">
                          <div className="mb-3 row">
                            <label className="col-lg-4 col-form-label">
                              Address
                            </label>
                            <div className="col-lg-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Address"
                                required
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-6">
                          <div className="mb-3 row">
                            <label className="col-lg-4 col-form-label">
                              State
                            </label>
                            <div className="col-lg-8">
                              <select
                                className="form-control"
                                value={state}
                                onChange={(e) => setState(e.target.value)}>
                                <option value="" disabled selected>
                                  Select State
                                </option>
                                {stateList?.map((item: any, index: number) => (
                                  <option
                                    key={index}
                                    value={item.name + "|" + item.id}>
                                    {item.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-6">
                          <div className="mb-3 row">
                            <label className="col-lg-4 col-form-label">
                              District
                            </label>
                            <div className="col-lg-8">
                              <select
                                className="form-control"
                                value={district}
                                onChange={(e) => setDistrict(e.target.value)}>
                                <option value="" disabled selected>
                                  Select District
                                </option>
                                {cityList?.map((item: any, index: number) => (
                                  <option key={index} value={item.id}>
                                    {item.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-6">
                          <div className="mb-3 row">
                            <label className="col-lg-4 col-form-label">
                              Pin Code
                            </label>
                            <div className="col-lg-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Pin Code"
                                required
                                value={pincode}
                                onChange={(e) => {
                                  const numericValue = e.target.value.replace(
                                    /\D/g,
                                    ""
                                  );
                                  setPinCode(numericValue);
                                }}
                                maxLength={6}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-6">
                          <div className="mb-3 row">
                            <label className="col-lg-4 col-form-label">
                              GST Number
                            </label>
                            <div className="col-lg-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter GST Number"
                                required
                                value={gstNo}
                                onChange={(e) => setGstNo(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="submit" className="btn btn-primary">
                      Update Profile
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default EditSellerProfile;
